import { DiffView } from '@keboola/design';

/** Renders a stored value as diff text; `undefined` becomes `null`, so an added field diffs against something. */
const toDiffText = (value: unknown): string => JSON.stringify(value ?? null, null, 2);

type Props = {
  attribute: string;
  oldValue: unknown;
  newValue: unknown;
  leftTitle?: string;
  rightTitle?: string;
};

/**
 * One attribute's before / after.
 *
 * - `DiffView` aligns the two sides, which whole 256 kB JSON schemas need to stay readable.
 */
export function AttributeDiff({
  attribute,
  oldValue,
  newValue,
  leftTitle = 'Before',
  rightTitle = 'After',
}: Props) {
  return (
    <div className="tw:flex tw:flex-col tw:gap-2">
      <h3 className="tw:m-0 tw:font-mono tw:text-sm">{attribute}</h3>
      <DiffView
        leftTitle={leftTitle}
        rightTitle={rightTitle}
        oldValue={toDiffText(oldValue)}
        newValue={toDiffText(newValue)}
      />
    </div>
  );
}
